import { __, contains, includes, pick } from 'ramda';

import { PROBATION_STATES, EMPLOYEED_STATES, EXCLUDED_STATES } from 'constants/person';
import { RECRUITMENT_TYPES } from 'constants/project';

export const getPersonItem = {
    workPlaces: (item) => {
        const workPlace = pick(['position', 'organization', 'experience'], item);
        workPlace.organization += item.department ? ` (${item.department})` : '';
        workPlace.experience = item.stillWorks ? `${workPlace.experience}${item.stillWorks}` : workPlace.experience;

        return workPlace;
    },
    education: pick(['institute', 'graduation', 'speciality'])
}

export const isProbationState = contains(__, PROBATION_STATES);
export const isEmployeedState = contains(__, EMPLOYEED_STATES);
export const isExcludedState = contains(__, EXCLUDED_STATES);

export const hasWhoTrudo = includes(__, RECRUITMENT_TYPES);
